(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('AuthenticationService', AuthenticationService)

    /** @ngInject */
    function AuthenticationService($q, $state, $location, $rootScope, MeService, ModuleService, ROUTES, LOCAL_STORAGE_ITEMS, KEYS) {
        let userData;
        let userUnits = [];
        let selectedUserUnit;
        let selectedUserData;
        let modules = [];

        const AuthenticationService = {
            // Getters
            getUserData: getUserData,
            getUserId: getUserId,
            getSelectedUnit: getSelectedUnit,
            getSelectedData: getSelectedData,
            getUnits: getUnits,
            getModules: getModules,

            // Methods
            logout: logout,
            isLogged: isLogged,
            isFranchisee: isFranchisee,
            handleSystemLoad: handleSystemLoad,
            canAccess: canAccess,
            setUnit: setUnit
        }

        return AuthenticationService;

        // Getters
        function getUserData() {
            return {
                Id: userData.Id,
                ExternalId: userData.ExternalId,
                Name: userData.Name,
                Email: userData.Email,
                Image: userData.Image,
                AccessLevel: selectedUserData.AccessLevel,
                Responsibility: selectedUserData.Responsibility,
                EconomicGroup: selectedUserData.Unit && selectedUserData.Unit.EconomicGroup ? selectedUserData.Unit.EconomicGroup : null,
                ClusterPerformance: selectedUserData.Unit && selectedUserData.Unit.EconomicGroup ? selectedUserData.Unit.EconomicGroup.ClusterPerformance : null,
                TicketCategory_Person: userData.TicketCategory_Person
            }
        }

        function getUserId() {
            return userData.Id;
        }

        function getModules() {
            return modules;
        }

        function getSelectedUnit() {
            return selectedUserUnit;
        }

        function getSelectedData() {
            return selectedUserData;
        }

        function getUnits() {
            return userUnits;
        }

        // Methods
        function logout(fromUser, withCallback = false) {
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_REFRESH);
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION);

            if (withCallback) {
                window.location.href = `${ROUTES.CENTRAL_CONTAS}login?ClientId=${KEYS.CLIENT_ID}&RedirectUrl=${ROUTES.APP}/oauthcallback&ReturnUrl=${$location.path()}`;
                return;
            }

            if (fromUser) {
                window.location.href = `${ROUTES.CENTRAL_CONTAS}login`;
                return;
            }

            if (angular.ISSAFARI)
                window.location.href = `${ROUTES.CENTRAL_CONTAS}login?ClientId=${KEYS.CLIENT_ID}&RedirectUrl=${ROUTES.APP}/oauthcallback&ReturnUrl=${$location.path()}`;
            else
                $state.go('app-auth.oauthcallback');
        }

        function isLogged() {
            const accessToken = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            const tokenExpiration = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION);

            return accessToken && tokenExpiration && moment(tokenExpiration).diff(moment(), 'hours') >= 2;
        }

        function isFranchisee() {
            return selectedUserData.AccessLevel.Id == 3 || selectedUserData.AccessLevel.Id == 4;
        }

        function handleSystemLoad() {
            let defer = $q.defer();
            const accessToken = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);

            if (accessToken) {
                if (userData) {
                    defer.resolve(userData);
                } else {
                    $q.all([MeService.getMe(accessToken), ModuleService.getAll()])
                        .then(success => {
                            prepareUserData(success[0], success[1], defer);

                            $rootScope.hideLoading = true;

                            defer.resolve(success);
                        }, error => {
                            $rootScope.hideLoading = true;

                            defer.reject(error);
                        })
                }
            } else {
                defer.reject({
                    error: 'User token not available from localStorage'
                });
            }

            return defer.promise;
        }

        function canAccess(transitionTo) {
            if (!userData)
                return false;

            if (transitionTo.url == '/' || (!transitionTo.isRestricted && !transitionTo.moduleId))
                return true;

            return true;
        }

        function setUnit(unitId, defer) {
            if (!defer)
                defer = $q.defer();

            let state = $state.current;

            let data = userData.Person_Unit.find((x) => {
                return x.UnitId == unitId;
            });

            if (data) {
                localStorage.setItem('SelectedUnitId', data.UnitId);

                selectedUserData = data;
                selectedUserUnit = data.Unit;

                if (!canAccess(state)) {
                    defer.reject({
                        error: 'User is not allowed',
                        redirTo: 'app.not-authorized'
                    });
                } else if (canAccess(state) && $location.path().indexOf('not-authorized') > 0) {
                    defer.reject({
                        error: 'User is allowed, wrong route',
                        redirTo: 'app.home'
                    });
                } else
                    defer.resolve(1);
            } else
                defer.reject('Error on recovering user local data');

            return defer.promise;
        }

        // Internal
        function prepareUserData(user, userModules, defer) {
            userUnits = [];

            let allowedUnitId;
            let selectedUnitId = parseInt(localStorage.getItem('SelectedUnitId'));

            if (selectedUnitId)
                allowedUnitId = selectedUnitId;

            for (let i = 0; i < user.Person_Unit.length; i++) {
                const userPersonUnit = user.Person_Unit[i];

                if (userPersonUnit.Unit)
                    userUnits.push(userPersonUnit.Unit);
            }

            userData = user;
            modules = userModules;

            //If we don't have user data or user units go to not authorized
            if (!userData || !userUnits.length) {
                defer.reject({
                    error: 'User doens\'t have data or units',
                    redirTo: 'app.not-authorized'
                });

                return defer.promise;
            }

            let allowedData = userUnits.find(x => (x.Id == allowedUnitId));

            if (!allowedData)
                allowedUnitId = userUnits[0].Id;

            setUnit(allowedUnitId, defer);
        }
    }
}());